import { createGlobalStyle } from "styled-components";
import faviconImage from "../../asset/favicon.ico";
import robotoRegularTtf from "../../asset/roboto-regular.ttf";
import robotoRegularWoff from "../../asset/roboto-regular.woff";
import robotoRegularWoff2 from "../../asset/roboto-regular.woff2";

export const theme = {

    white: "#ffffff",
    black: "#505050",

    primaryLighter: "#C8686D",
    primaryLight: "#911319",
    primaryDark: "#911319",

    greyLightest: "#F7F7F7",
    greyLighter: "#EFEEEE",
    greyLight: "#D9D9D9",
    greyDark: "#BDC5C8",
    greyDarker: "#898989",

    redLight: "#FCE5E5",
    redDark: "#F98693",
    redDarker: "#DE3F52",

    greenLight: "#00cc00",
    greenDark: "#5AB248",

    boxShadow: "0 0 20px -5px #34484d",
};

(() => {
    //load favicon
    const link = document.createElement("link");
    link.rel = "icon";
    link.href = faviconImage;
    link.type = "image/x-icon";
    document.head.appendChild(link);

    //load font face
    const style = document.createElement("style");
    style.textContent = `
        @font-face {
            font-family: 'Roboto';
            src: local('Roboto Regular'), local('Roboto-Regular'),
                url(${robotoRegularWoff}) format('woff'),
                url(${robotoRegularWoff2}) format('woff2'),
                url(${robotoRegularTtf}) format('truetype');
            font-weight: 400;
            font-style: normal;
        }`;
    document.head.appendChild(style);
})();

export const GlobalStyle = createGlobalStyle`
    html, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote,
    pre, a, abbr, acronym, address, big, cite, code, del, dfn, em, img, ins, kbd, q, s,
    samp, small, strike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, ol, ul,
    li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td,
    article, aside,  canvas, details, embed, figure, figcaption, footer, header, hgroup,
    menu, nav, output, ruby, section, summary, time, mark, audio, video {
        outline: none;
        margin: 0;
        padding: 0;
        border: 0;
        font: inherit;
        font-size: 100%;
        vertical-align: baseline;
    }
    article, aside, details, figcaption, figure, footer, header, hgroup, menu, nav, section {
        display: block;
    }
    body {
        line-height: 1;
    }
    ol, ul {
        list-style: none;
    }
    blockquote, q {
        quotes: none;
    }
    blockquote:before, blockquote:after, q:before, q:after {
        content: "";
        content: none;
    }
    table {
        border-collapse: collapse;
        border-spacing: 0;
    }
    html, body, input, textarea, select, button {
        font-family: "Roboto", sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
    html, body {
        height: 100%;
        overflow-y: hidden;
        color: ${props => props.theme.black};
    }
    input, textarea, select {
        &:disabled {
            color: ${props => props.theme.black};
        }
    }
    input, textarea, select, button {
        margin: 0;
        outline: none;
        font-size: 14px;
    }
    ::-moz-focus-inner {
        border:0;
    }
`;